<template>
  <div class="page-shell">
    <SiteHeader :active="active" />
    <main class="page-main">
      <slot />
    </main>
  </div>
</template>

<script>
import SiteHeader from './SiteHeader.vue'

export default {
  name: 'PageShell',
  components: {
    SiteHeader
  },
  props: {
    active: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.page-shell {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: #fff;
}

.page-main {
  flex: 1;
}
</style>
